import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollHandler = () => {
  let location = useLocation();

  useEffect(() => {
    if (location.hash.length === 0) location.hash = '/';
    const element = document.getElementById(location.hash);
    // If I'm deep into site like in a wallet, i don't want website to scroll to top. One slash
    const numSlash = (location.pathname.match(/\//g) || []).length;

    if (numSlash < 2) {
      setTimeout(() => {
        window.scrollTo({
          behavior: element ? 'smooth' : 'auto',
          top: element ? element.offsetTop : 0,
        });
      }, 100);
    }
  }, [location]);

  return null;
};

export default ScrollHandler;
